export const NAME_VARIABLE = '{{nome}}'
export const COMPANY_VARIABLE = '{{empresa}}'

export const MESSAGES = {
  INVALID_FORMAT: 'Formato inválido',
  REQUIRED_FIELD: 'Campo obrigatório',
  REQUIRED_PERSONALIZATION_VARIABLE: `Inclua a variável ${NAME_VARIABLE} ou ${COMPANY_VARIABLE} na mensagem`,
  PASSWORD_MIN: 'A senha deve conter no mínimo 8 caracteres',
  PASSWORD_MUST_MATCH: 'As senhas devem combinar',
  INVALID_DATE_FORMAT: 'Formato de data inválido (use DD/MM/AAAA)',
  INVALID_DATE: 'Data inválida',
};

export function hasPersonalizationVariable(value?: string | null) {
  return Boolean(
    value?.includes(NAME_VARIABLE) || value?.includes(COMPANY_VARIABLE)
  )
}

export function hasPersonalizationVariableWhenFilled(value?: string | null) {
  return !value?.trim() || hasPersonalizationVariable(value)
}

export const YOUTUBE_REGEX =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)[\w-]{11}(&.*)?$/;
